<template>
    <Doughnut :data="chartData" :options="chartOptions" />
</template>

<script>
import { Doughnut } from "vue-chartjs";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export default {
    name: "ChartElementDeveloper",
    components: { Doughnut },
    props:{
        datachart:{
            type: Object,
            required: true
        }
    },
    data() {
        return {
            chartData: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: ["#f5a623", "#346cf0", "#169b7b"],
                        borderWidth: 0,
                    },
                ],
            },
            chartOptions: {
                responsive: true,
                cutout: "40%",
                plugins: {
                    legend: {
                        display: true,
                        position: "right",
                        labels: {
                            usePointStyle: true,
                            pointStyle: "circle",
                            boxWidth: 10,
                            boxHeight: 10,
                            padding: 20,
                            color: "#000",
                            font: {
                                size: 14,
                                weight: "normal",
                            },
                            generateLabels: (chart) => {
                                const data = chart.data;
                                const dataset = data.datasets[0];

                                return data.labels.map((label, i) => ({
                                    text: `${label.replace('_', ' ')}: ${dataset.data[i]} MB`,
                                    fillStyle: dataset.backgroundColor[i],
                                    strokeStyle: dataset.backgroundColor[i],
                                    pointStyle: "circle",
                                    index: i,
                                }));
                            },
                        },
                    },
                    tooltip: {
                        enabled: true,
                        callbacks: {
                            label: (tooltipItem) => {
                                return `${tooltipItem.label}: ${tooltipItem.raw} MB`;
                            },
                        },
                    },
                },
            },
        };
    },
    created(){

        this.chartData.labels = Object.keys(this.datachart);
        this.chartData.labels.forEach((value) => {

            this.chartData.datasets[0].data.push(this.datachart[`${value}`]);

        });

    }
};
</script>
